import React, { useMemo, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout, Checkbox, Row, Col, Form, Input, Select, Tooltip, Button, Popconfirm,Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import {
  InfoCircleOutlined, EditOutlined, DeleteOutlined, PlusCircleOutlined
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
// import StepSider from "./StepSider";
import { authUserData } from "../../utils/Helper";
import companyimg from "../../image/userimg.png";
import { getRequest, postRequest } from "../../axios";
import { ErrorNotificationMsg, SuccessNotificationMsg } from "../../utils/Notifications";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";

const onChange = (e) => {
  console.log(`checked = ${e.target.checked}`);
};
const { Content } = Layout;
const handleChange = (value) => {
  console.log(`selected ${value}`);
};
const ArchivePRApprovalHierarchy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [arrow, setArrow] = useState('Show');
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [totalCount, settotalCount] = useState(0)
  const [PRApprovalList, setPRApprovalList] = useState([]);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10
  });
  useEffect(() => {
    PRApprovalHierarchyGetById();
  }, [reload, state]);

  const PRApprovalHierarchyGetById = async () => {
    setLoading(true);
    try {
      //let apiResponse = await getRequest(`pr-release-restore/?company_id=${CompanyId}`, state);
      let apiResponse = await getRequest(
        `pr-release-restore/${CompanyId}/get-archive-pr-release-by-company/`,
        state
      );
      if (apiResponse.data.data) {
        const sortedData = apiResponse.data.data.sort((a, b) => {
          return b.id - a.id;
        });
        setPRApprovalList(sortedData);
        settotalCount(apiResponse.data.count);
      } else {
        ErrorNotificationMsg(t("error_in_list_prapproval_hierarchy"));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const handleRestore = async (id) => {
    try {
      let apiResponse = await postRequest("pr-release-restore/", {
        deleted: [id], // Send the ID in an array as expected by your API
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("prapproval_hierarchy_restore_successfully"));
        setReload(!reload); // Trigger reload of employee list
        navigate("/pr-approval-heirarchy-list"); // Navigate to the employee list page after restore
      } else {
        ErrorNotificationMsg(t("error_in_restore_prapproval_hierarchy"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };
  const mergedArrow = useMemo(() => {
    if (arrow === 'Hide') {
      return false;
    }
    if (arrow === 'Show') {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);
  const colors = ["#094E8F"];
  const handleArchive = async (id = "") => {
    // let ids = selectedRow;
    // let id =[]
    //  if (ids.length === 0) {
    //   ids.push(id);
    // }
    try {
      let apiResponse = await postRequest("pr-release-archive/", {
        //deleted: ids,
        deleted: [id],
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - id?.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        //SuccessNotificationMsg(t("Site location archive successfully"));
        SuccessNotificationMsg(apiResponse.data.message); 
        //setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
        ErrorNotificationMsg(t("error_in_archive_delivery_address"));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };
  return (
    <>
  <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
              
                <h3>Archive PR Release Hierarchy</h3>
    
                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </Breadcrumb.Item>
    
                  <Breadcrumb.Item>Archive PR Release Hierarchy</Breadcrumb.Item>
                </Breadcrumb>
                </div>
             
              
            </div>
          </div>
     
          <Content className="stepscontentwrap">
           
            <div className="stepsContent">

              <div className="cardswraper">
                <Row gutter={24}>
                  {/* <Col
                    xs={24}
                    sm={24}
                    md={12}
                    xl={8}
                    xxl={6}
                  >
                    <div className="stepcard addsite">
                      <div>
                        <Link to="/pr-approval-heirarchy">
                          <PlusCircleOutlined />
                        </Link>
                        <h5>Add Site Wise PR Release <br />Hierarchy</h5>
                      </div>
                    </div>
                  </Col> */}

                  {PRApprovalList.map((item) => (
                    <Col
                      key={item.id}
                      xs={24}
                      sm={24}
                      md={12}
                      xl={8}
                      xxl={6}
                    >
                      <div className="stepcard sitecard">
                        <div className="cardtitle ">
                          {/* Adani Shantigram */}
                          {item.site_name}
                          {/* {records.map(record => ( */}

                          <div key={item.id} className="action">
                            {/* <Link to={`/pr-approval-heirarchy/edit/${item.id}`}>
                              <EditOutlined /></Link> */}
                              <Popconfirm
                                className="action"
                                title={t("Are you sure you want to restore")}
                                okText={t("pop_ok")}
                                cancelText={t("pop_cancel")}
                                onConfirm={() => handleRestore(item.id)}
                              >
                                <ArchiveRestore style={{height:'25px', cursor:'pointer'}}/>
                              </Popconfirm>
                          </div>

                        </div>
                        {item.pr_second_release && (
                          <div className="hirachycardrow">
                            <div className="hirachysubtitle">PR Second Release</div>
                            <Row gutter={16}>
                              <Col xs={12}>
                                <Form.Item><label>PR Value</label>
                                  <span className="value">₹ {item.pr_second_value_up_to.toLocaleString()}</span>
                                </Form.Item>
                              </Col>
                              <Col xs={12}>
                                <Form.Item><label>Release Manager </label>
                                  <span className="value">{item.pr_second_release_manager.first_name}</span>
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        )}
                        {item.pr_third_release && (
                          <div className="hirachycardrow">
                            <div className="hirachysubtitle">PR Third Release</div>
                            <Row gutter={16}>
                              <Col xs={12}>
                                <Form.Item><label>PR Value</label>
                                  <span className="value">₹ {item.pr_third_value_up_to.toLocaleString()}</span>

                                </Form.Item>
                              </Col>
                              <Col xs={12}>
                                <Form.Item><label>Release Manager </label>
                                  <span className="value">{item.pr_third_release_manager.first_name}</span>
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        )}
                        {item.pr_fourth_release && (
                          <div className="hirachycardrow">
                            <div className="hirachysubtitle">PR Fourth Release</div>
                            <Row gutter={16}>
                              <Col xs={12}>
                                <Form.Item><label>PR Value</label>
                                  <span className="value">₹ {item.pr_fourth_value_up_to.toLocaleString()}</span>
                                </Form.Item>
                              </Col>
                              <Col xs={12}>
                                <Form.Item><label>Release Manager </label>
                                  <span className="value">{item.pr_fourth_release_manager.first_name}</span>
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        )}
                        {item.pr_fifth_release && (
                          <div className="hirachycardrow">
                            <div className="hirachysubtitle">PR Fifth Release</div>
                            <Row gutter={16}>
                              <Col xs={12}>
                                <Form.Item><label>PR Value</label>
                                  <span className="value">₹ {item.pr_fifth_value_up_to.toLocaleString()}</span>
                                </Form.Item>
                              </Col>
                              <Col
                                xs={12}
                              >
                                <Form.Item

                                ><label>Release Manager </label>
                                  <span className="value">{item.pr_fifth_release_manager.first_name}</span>
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        )}
                      </div>
                    </Col>

                  ))}
                  {/* <Col
                    xs={24}
                    sm={24}
                    md={12}
                    xl={8}
                    xxl={6}
                  >
                    <div className="stepcard sitecard">
                      <div className="cardtitle ">
                        Adani Shantigram
                        <div className="action">
                          <EditOutlined /> <DeleteOutlined />
                        </div>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Second Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Nirav Kukadia</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Third Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Dinesh Rathod</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fourth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Sanjoy sharma</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fifth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Hiren Kukadiya</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>  */}




                  {/* <Col
                    xs={24}
                    sm={24}
                    md={12}
                    xl={8}
                    xxl={6}
                  >
                    <div className="stepcard sitecard">
                      <div className="cardtitle ">
                        Adani Shantigram
                        <div className="action">
                          <EditOutlined /> <DeleteOutlined />
                        </div>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Second Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Nirav Kukadia</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Third Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Dinesh Rathod</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fourth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Sanjoy sharma</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fifth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Hiren Kukadiya</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    xl={8}
                    xxl={6}
                  >
                    <div className="stepcard sitecard">
                      <div className="cardtitle ">
                        Adani Shantigram
                        <div className="action">
                          <EditOutlined /> <DeleteOutlined />
                        </div>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Second Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Nirav Kukadia</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Third Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Dinesh Rathod</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fourth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Sanjoy sharma</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fifth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Hiren Kukadiya</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    xl={8}
                    xxl={6}
                  >
                    <div className="stepcard sitecard">
                      <div className="cardtitle ">
                        Adani Shantigram
                        <div className="action">
                          <EditOutlined /> <DeleteOutlined />
                        </div>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Second Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Nirav Kukadia</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Third Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Dinesh Rathod</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fourth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Sanjoy sharma</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fifth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Hiren Kukadiya</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    xl={8}
                    xxl={6}
                  >
                    <div className="stepcard sitecard">
                      <div className="cardtitle ">
                        Adani Shantigram
                        <div className="action">
                          <EditOutlined /> <DeleteOutlined />
                        </div>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Second Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Nirav Kukadia</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Third Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Dinesh Rathod</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fourth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Sanjoy sharma</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fifth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Hiren Kukadiya</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    xl={8}
                    xxl={6}
                  >
                    <div className="stepcard sitecard">
                      <div className="cardtitle ">
                        Adani Shantigram
                        <div className="action">
                          <EditOutlined /> <DeleteOutlined />
                        </div>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Second Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Nirav Kukadia</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Third Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Dinesh Rathod</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fourth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Sanjoy sharma</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                      <div className="hirachycardrow">
                        <div className="hirachysubtitle">PR Fifth Release</div>
                        <Row gutter={16}>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>PR Value</label>
                              <span className="value">₹ 5,00,000</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={12}
                          >
                            <Form.Item

                            ><label>Release Manager </label>
                              <span className="value">Hiren Kukadiya</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col> */}

                </Row>
              </div>

            </div>
            {/* <div className="stepsFooter">
              <Button
                cursor="pointer"
                type="secondary"
                className="primary"
                onClick={() => navigate("/manage-user-step")}
              >
                Previous
              </Button>
              <Button
                cursor="pointer"
                type="primary"
                className="primary"
                onClick={() => navigate("/business-setting-step")}
              >
                Save & Next
              </Button>
            </div> */}
          </Content>
       
    </>
  );
};

export default ArchivePRApprovalHierarchy;
